<template>
  <!-- 供应商管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="listData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      v-model="tableForm"
      :permission="permissionList"
      :before-open="beforeOpenForm"
      :before-close="beforeCloseForm"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <!-- <template slot="menuLeft">
        <el-button
          v-if="permissionList.importBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-upload2"
          @click="isImportDialogShow = true"
          >导入
        </el-button>
        <wq-exportData
          v-if="permissionList.exportBtn"
          :moduleType="103"
          @exportExcel="exportExcel"
        ></wq-exportData>
      </template> -->
      <template slot="elderlyIdSearch">
        <el-select style="width: 100%" placeholder="老人" v-model="searchForm.elderlyId" clearable>
          <el-option
            v-for="(item, index) in elderlyList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="fileListForm">
        <vUpload
          :limit="10"
          :fileList.sync="tableForm.fileList"
          :disabled="formType == 'view'"
        ></vUpload>
      </template>
    </avue-crud>

    <el-dialog
      title="供应商管理数据导入"
      append-to-body
      :visible.sync="isImportDialogShow"
      width="555px"
      accept="vnd.ms-excel"
      :close-on-click-modal="false"
    >
      <avue-form
        :option="importOption"
        :upload-after="importUploadAfter"
        :upload-before="importUploadBefore"
      >
        <template slot="downloadAction">
          模板下载:
          <el-button type="primary" size="small" icon="el-icon-download" @click="exportDemoExcel">
            模板下载
          </el-button>
        </template>
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import vUpload from '@/views/components/v-upload';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import { getNursinghomeList } from '../api/public.js';
import { getPageListApi, addApi, updateApi, removeApi } from '../api/supplier';

export default {
  components: {
    vUpload,
  },
  data() {
    return {
      oldNursinghomeId: '', // 旧养老院id，重置搜索条件和新增时需要使用
      nursinghomeList: [], // 养老院列表
      elderlyList: [], // 老人列表
      // 搜索表单
      searchForm: {
        nursinghomeId: '',
      },
      tableForm: {}, // crud表单
      formType: '', // curd表单类型
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      listData: [], // 列表数据
      loading: false,
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 数据的表格展示配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        index: true,
        viewBtn: true,
        dialogClickModal: false,
        searchMenuSpan: 6,
        searchLabelWidth: 100,
        selection: true,
        tip: false,
        labelWidth: 100,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            disabled: true,
            search: true,
            searchClearable: false,
            rules: [
              {
                required: true,
                message: '请选择服务网点',
                trigger: 'change',
              },
            ],
          },
          {
            label: '供应商类型',
            prop: 'type',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_partner_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            type: 'select',
            search: true,
            rules: [
              {
                required: true,
                message: '请选择供应商类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '供应商名称',
            prop: 'name',
            search: true,
            maxlength: '30',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入供应商名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '供应商等级',
            prop: 'level',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_partner_level_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择供应商类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '联系人',
            prop: 'contactName',
            maxlength: '30',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入联系人',
                trigger: 'change',
              },
            ],
          },
          {
            label: '联系电话',
            prop: 'contactTel',
            maxlength: '30',
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入联系电话',
                trigger: 'change',
              },
            ],
          },
          // 分割线
          {
            label: '税号',
            prop: 'taxNo',
            hide: true,
            showColumn: false,
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入税号',
              },
            ],
          },
          {
            label: '注册地址',
            prop: 'addr',
            hide: true,
            showColumn: false,
            maxlength: 40,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入注册地址',
              },
            ],
          },
          {
            label: '开户银行',
            prop: 'bankName',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入开户银行',
              },
            ],
          },
          {
            label: '银行账户',
            prop: 'bankAccount',
            hide: true,
            showColumn: false,
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入银行账户',
              },
              { pattern: /^([1-9]{1})(\d{7,29})$/, message: '请输入8位至30位的正确银行账号！' },
            ],
          },
          {
            label: '法定代理人',
            prop: 'legalAgent',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入法定代理人',
              },
            ],
          },
          {
            label: '法人身份证号',
            prop: 'identityCardNo',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
            rules: [{ pattern: /^\d{15}|\d{18}$/, message: '格式错误' }],
          },
          {
            label: '邮政编码',
            prop: 'postCode',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '公司电话',
            prop: 'officeTel',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
            rules: [
              {
                pattern:
                  /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/,
                message: '请输入正确得座机或手机号码！',
              },
            ],
          },
          {
            label: '公司传真',
            prop: 'fax',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '公司邮箱',
            prop: 'email',
            hide: true,
            showColumn: false,
            maxlength: 20,
            showWordLimit: true,
            rules: [
              {
                pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                message: '请输入正确邮箱格式！',
              },
            ],
          },
          {
            label: '电子附件',
            prop: 'fileList',
            hide: true,
            showColumn: false,
            span: 24,
            formslot: true,
          },
        ],
      },
      // 数据导入导出
      selectionIds: '', // 选中的数据id集合
      isImportDialogShow: false, // 导入弹框是否显示着
      importOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/nursing/partner/imporSupplier',
            data: {},
          },
          {
            label: '模板下载',
            prop: 'downloadAction',
            formslot: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.supplier_view, false),
        addBtn: this.vaildData(this.permission.supplier_add, false),
        editBtn: this.vaildData(this.permission.supplier_edit, false),
        delBtn: this.vaildData(this.permission.supplier_del, false),
        importBtn: this.vaildData(this.permission.supplier_import, false),
        exportBtn: this.vaildData(this.permission.supplier_export, false),
      };
    },
  },
  created() {
    getNursinghomeList().then(({ data }) => {
      this.nursinghomeList = data || [];
      if (this.nursinghomeList.length > 0) {
        this.findObject(this.tableOption.column, 'nursinghomeId').dicData = this.nursinghomeList;
        this.searchForm.nursinghomeId = this.nursinghomeList[0].id;
        this.oldNursinghomeId = this.searchForm.nursinghomeId;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 330; // 表格区域初始化高度
      const searchH = 57; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    loadData(page) {
      if (this.nursinghomeList.length == 0) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        nursinghomeId: this.oldNursinghomeId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.oldNursinghomeId = this.searchForm.nursinghomeId;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    beforeOpenForm(done, type) {
      this.needCloseConfirm = true;
      this.formType = type;
      if (type == 'add') {
        this.tableForm = {
          nursinghomeId: this.oldNursinghomeId,
          fileList: [],
        };
      } else {
        if (type == 'view') {
          this.needCloseConfirm = false;
        }
      }
      done();
    },
    beforeCloseForm(done, type) {
      if (!this.needCloseConfirm) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          done();
        });
      }
    },
    rowSave(row, done, loading) {
      addApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      updateApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeApi({
            ids: row.id,
          });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
    selectionChange(val) {
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.selectionIds = Ids.join(',');
    },
    // 模板下载
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        window.open(
          `/api/nursing/partner/supplierDemoExcel?${
            this.website.tokenHeader
          }=${getToken()}&nursinghomeId=` + this.searchForm.nursinghomeId
        );
      });
    },
    importUploadBefore(file, done, loading, column) {
      column.data.nursinghomeId = this.query.nursinghomeId;
      done(file, column);
    },
    importUploadAfter(res, done) {
      if (!res) {
        this.$message({
          message: '上传成功！',
          type: 'success',
        });
        this.isImportDialogShow = false;
        this.loadData();
      }
      done();
    },
    // 导出数据
    exportExcel(data) {
      let saveIds = data.exportExcelSelectionRadio == '1' ? '' : this.selectionIds;
      if (saveIds.length == 0 && data.exportExcelSelectionRadio == 2) {
        this.$message({
          message: '请选择需要导出的数据！',
          type: 'warning',
        });
        return;
      }
      this.$confirm('是否导出数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let nursinghomeId = this.searchForm.nursinghomeId || '';
        let type = this.searchForm.type || '';
        let name = this.searchForm.name || '';
        if (data.exportExcelSelectionRadio == 2) {
          window.open(
            `/api/nursing/partner/imporExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${
              data.configExport
            }&nursinghomeId=${nursinghomeId}&saveIds=${saveIds}`
          );
        } else {
          window.open(
            `/api/nursing/partner/imporExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${
              data.configExport
            }&nursinghomeId=${nursinghomeId}&type=${type}&name=${name}`
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
